import { useEffect } from 'react';

interface BaseProps {
  children: JSX.Element;
}

type TrackFnProps<
  ViewEvent extends { event: string; attributes: Record<string, unknown> },
> = BaseProps & {
  trackFn: (event: ViewEvent) => void;
  data: ViewEvent;
  onMount?: never;
};

type OnMountProps = BaseProps & {
  trackFn?: never;
  data?: never;
  onMount: () => void;
};

type TrackOnMountProps<
  ViewEvent extends { event: string; attributes: Record<string, unknown> },
> = TrackFnProps<ViewEvent> | OnMountProps;

export function TrackOnMount<
  ViewEvent extends { event: string; attributes: Record<string, unknown> },
>({
  children,
  trackFn,
  data,
  onMount,
}: TrackOnMountProps<ViewEvent>): JSX.Element {
  useEffect(() => {
    if (onMount) {
      onMount();
    } else {
      trackFn(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
}
